import { InjectionToken, Injectable, Inject, ɵɵdefineInjectable, ɵɵinject, EventEmitter, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { __awaiter } from 'tslib';
import { CallHttp, DialogService } from 'vesta';
import * as firebase from 'firebase/app';
import { apps, initializeApp, database, messaging, auth } from 'firebase/app';
import 'firebase/database';
import 'firebase/messaging';
import 'firebase/auth';
import { Subject } from 'rxjs';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/settings-firebase.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function SettingsFirebase() { }
if (false) {
    /** @type {?} */
    SettingsFirebase.prototype.apiKey;
    /** @type {?} */
    SettingsFirebase.prototype.databaseURL;
    /** @type {?} */
    SettingsFirebase.prototype.messagingSenderId;
    /** @type {?} */
    SettingsFirebase.prototype.PublicVapidKey;
    /** @type {?} */
    SettingsFirebase.prototype.projectId;
    /** @type {?} */
    SettingsFirebase.prototype.appId;
    /** @type {?} */
    SettingsFirebase.prototype.SistemaId;
}
/**
 * @record
 */
function Environment() { }
if (false) {
    /** @type {?} */
    Environment.prototype.production;
}
/** @type {?} */
let Settings_FireBase = new InjectionToken('Settings_FireBase');
/** @type {?} */
let Settings_FireBase_Temp = new InjectionToken('Settings_FireBase_Temp');
/** @type {?} */
let EnvironmentToken = new InjectionToken('Environment');
/** @type {?} */
let BASEURL_FIREBASE = new InjectionToken('BASEURLFIREBASE');

/**
 * @fileoverview added by tsickle
 * Generated from: lib/firebase-connect.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//import { environment } from 'src/environments/environment';
////require("firebase/app");
//require("@firebase/database");
//require("@firebase/messaging");
//require("@firebase/auth");
class FirebaseConnectService {
    /**
     * @param {?} settings
     */
    constructor(settings) {
        this.settings = settings;
        let [app] = apps;
        if (app == null) {
            firebase;
            this.App = initializeApp(settings);
            this.DataBase = this.GetDataBase();
            this.Messaging = this.GetMessaging();
            this.Auth = this.GetAuth();
        }
        else {
            this.App = app;
            this.DataBase = this.GetDataBase();
            this.Messaging = this.GetMessaging();
            this.Auth = this.GetAuth();
        }
    }
    /**
     * @return {?}
     */
    GetDataBase() {
        return database(this.App); //firebase.database(this.settings.databaseURL);//firebase.database(this.App);
    }
    /**
     * @return {?}
     */
    GetMessaging() {
        return messaging(this.App); //firebase.messaging(this.App);
    }
    /**
     * @return {?}
     */
    GetAuth() {
        return auth(this.App); //firebase.auth(this.App);
    }
}
FirebaseConnectService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
FirebaseConnectService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [Settings_FireBase,] }] }
];
/** @nocollapse */ FirebaseConnectService.ngInjectableDef = ɵɵdefineInjectable({ factory: function FirebaseConnectService_Factory() { return new FirebaseConnectService(ɵɵinject(Settings_FireBase)); }, token: FirebaseConnectService, providedIn: "root" });
if (false) {
    /** @type {?} */
    FirebaseConnectService.prototype.App;
    /** @type {?} */
    FirebaseConnectService.prototype.Messaging;
    /** @type {?} */
    FirebaseConnectService.prototype.DataBase;
    /** @type {?} */
    FirebaseConnectService.prototype.Auth;
    /**
     * @type {?}
     * @private
     */
    FirebaseConnectService.prototype.settings;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/local-storage-key-firebase.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const Key_FireBase_DateTime = 'firebase.token_id.datetime';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/web-push-firebase.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var moment = require('moment');
class WebPushFirebaseService {
    /**
     * @param {?} fireBaseConnect
     * @param {?} callHttp
     * @param {?} settings
     * @param {?} environment
     * @param {?} baseURL
     */
    constructor(fireBaseConnect, callHttp, settings, environment, baseURL) {
        this.fireBaseConnect = fireBaseConnect;
        this.callHttp = callHttp;
        this.settings = settings;
        this.environment = environment;
        this.baseURL = baseURL;
        this.OnMessaging = new EventEmitter();
        this.TokenIdSubject = new Subject();
        this.FocusSubject = new Subject();
        this._Timer = null;
    }
    /**
     * @param {?} tokenId
     * @return {?}
     */
    set TokenId(tokenId) {
        this._TokenId = tokenId;
        this.TokenIdSubject.next(tokenId);
    }
    /**
     * @return {?}
     */
    get TokenId() {
        return this._TokenId;
    }
    /**
     * @param {?} user
     * @return {?}
     */
    RequestPermission(user) {
        this.user = user;
        /** @type {?} */
        let promise = new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            if (this.fireBaseConnect.Auth.currentUser != null) {
                if (this.fireBaseConnect.Auth.currentUser.uid.toLowerCase() != this.user.Id)
                    this.fireBaseConnect.Auth.signOut();
            }
            this.fireBaseConnect.Messaging.requestPermission().then((/**
             * @return {?}
             */
            () => __awaiter(this, void 0, void 0, function* () {
                console.log('Notification permission granted.');
                if ('serviceWorker' in navigator && 'PushManager' in window) {
                    /** @type {?} */
                    let serviceWorker = this.environment.production ? 'assets/firebase-messaging-sw.js' : 'assets/firebase-messaging-sw-dev.js';
                    navigator.serviceWorker.register(serviceWorker)
                        .then((/**
                     * @param {?} swReg
                     * @return {?}
                     */
                    (swReg) => __awaiter(this, void 0, void 0, function* () {
                        console.log('Service Worker is registered', swReg);
                        /** @type {?} */
                        var user = this.fireBaseConnect.Auth.currentUser;
                        if (user) {
                            resolve(true);
                            this.ValidTimeAuthentication().then((/**
                             * @param {?} id
                             * @return {?}
                             */
                            id => {
                                this.TokenId = id;
                                this.NotificacionUserRegistrado(swReg);
                            }));
                        }
                        else {
                            /** @type {?} */
                            let resp = yield this.AutenticarUsuarioAndRecibirNotificacion(swReg);
                            resolve(resp);
                        }
                    })))
                        .catch((/**
                     * @param {?} error
                     * @return {?}
                     */
                    error => {
                        console.error('Service Worker Error', error);
                        resolve(false);
                    }));
                }
                else {
                    // this.pushNotificationStatus.isSupported = false;
                }
            }))).catch((/**
             * @param {?} err
             * @return {?}
             */
            function (err) {
                console.log('Unable to get permission to notify.', err);
            }));
            this.fireBaseConnect.Messaging.onTokenRefresh((/**
             * @return {?}
             */
            () => {
                this.fireBaseConnect.Messaging.getToken().then((/**
                 * @param {?} token
                 * @return {?}
                 */
                (token) => {
                    this.TokenMessaging = token;
                    console.log(token);
                    console.log(this.userName.Token);
                    //if (this.userName.Token == null) this.SaveDataBase(token);
                    if (this.userName.Token != token)
                        this.UpdateToken();
                    this.OnMessage();
                }));
            }));
            this.EventFocusMensajes();
        }));
        return promise;
    }
    /**
     * @private
     * @param {?} swReg
     * @return {?}
     */
    AutenticarUsuarioAndRecibirNotificacion(swReg) {
        /** @type {?} */
        let promise = new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            let token = yield this.GetTokenHr();
            if (token == null)
                return void 0;
            token.subscribe((/**
             * @param {?} response
             * @return {?}
             */
            response => {
                this.TokenAuth = response;
                this.fireBaseConnect.Auth.signInWithCustomToken(this.TokenAuth).then((/**
                 * @param {?} user
                 * @return {?}
                 */
                (user) => {
                    resolve(true);
                    this.ValidTimeAuthentication()
                        .then((/**
                     * @param {?} id
                     * @return {?}
                     */
                    (id) => __awaiter(this, void 0, void 0, function* () {
                        this.NotificacionUserRegistrado(swReg);
                    }))).catch((/**
                     * @param {?} error
                     * @return {?}
                     */
                    error => {
                        console.error(error);
                    }));
                }), (/**
                 * @param {?} error
                 * @return {?}
                 */
                error => {
                    console.log(error.code);
                    console.error(error.message);
                    resolve(false);
                }));
            }));
        })));
        return promise;
    }
    /**
     * @private
     * @return {?}
     */
    CheckTokenIdUser() {
        return __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            let time = yield this.time();
            if (this._Timer == null)
                this.TimerInit(time);
            else
                this.ResetTimer(time);
        });
    }
    /**
     * @private
     * @param {?} time
     * @return {?}
     */
    TimerInit(time) {
        /** @type {?} */
        let timeToken = moment(localStorage.getItem(Key_FireBase_DateTime));
        /** @type {?} */
        let timeNow = moment(time.datetime);
        /** @type {?} */
        let diff = timeNow.diff(timeToken, 'milliseconds');
        this._Timer = setInterval((/**
         * @return {?}
         */
        () => {
            diff += 10000;
            timeNow.add(10000, 'milliseconds');
            console.debug(`Check Time Token Id Firebase`, diff);
            console.debug(`Check Time Token Id Firebase`, timeNow.toDate());
            if (diff >= 3590000) {
                diff = 0; //timeNow.diff(timeToken, 'milliseconds');
                this.TokenIdNotificacion(true).then((/**
                 * @param {?} id
                 * @return {?}
                 */
                (id) => {
                    timeToken = moment(localStorage.getItem(Key_FireBase_DateTime));
                    diff = timeNow.diff(timeToken, 'milliseconds');
                }));
            }
        }), 10000);
    }
    /**
     * @private
     * @param {?} time
     * @return {?}
     */
    ResetTimer(time) {
        clearTimeout(this._Timer);
        this.TimerInit(time);
    }
    /**
     * @private
     * @param {?=} refresh
     * @param {?=} first
     * @return {?}
     */
    TokenIdNotificacion(refresh = false, first = false) {
        /** @type {?} */
        let promise = new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            //let force = refresh ? true : null;
            this.fireBaseConnect.Auth.currentUser.getIdToken(refresh).then((/**
             * @param {?} id
             * @return {?}
             */
            (id) => __awaiter(this, void 0, void 0, function* () {
                if (refresh) {
                    console.log(`Refresh Token id ------ ${id}`);
                    yield this.SaveTime();
                }
                ;
                if (!refresh)
                    console.log(`Token id ------ ${id}`);
                if (first)
                    yield this.SaveTime();
                this.TokenId = id;
                resolve(id);
            }))).catch((/**
             * @param {?} error
             * @return {?}
             */
            error => {
                reject(error);
            }));
        }));
        return promise;
    }
    /**
     * @private
     * @return {?}
     */
    SaveTime() {
        return __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            let time = yield this.time();
            localStorage.setItem(Key_FireBase_DateTime, time.datetime);
            console.debug(`Start Token Id Firebase`, moment(time.datetime).toDate());
        });
    }
    /**
     * @private
     * @return {?}
     */
    time() {
        return __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            let time = yield fetch(`https://worldtimeapi.org/api/ip`);
            if (time.ok) {
                return time.json();
            }
        });
    }
    /**
     * @private
     * @return {?}
     */
    ValidTimeAuthentication() {
        /** @type {?} */
        let promise = new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            let timeLocalStorage = localStorage.getItem(Key_FireBase_DateTime);
            /** @type {?} */
            let timeNow = yield this.time();
            /** @type {?} */
            let first = false;
            if (timeLocalStorage == null) {
                timeLocalStorage = timeNow.datetime;
                first = true;
            }
            ;
            /** @type {?} */
            let time = moment(timeLocalStorage);
            /** @type {?} */
            let now = moment(timeNow.datetime);
            /** @type {?} */
            let diff = now.diff(time, 'hours');
            console.log(diff, 'h');
            if (diff > 0) {
                this.TokenIdNotificacion(true).then((/**
                 * @param {?} id
                 * @return {?}
                 */
                id => {
                    resolve(id);
                })).catch((/**
                 * @param {?} error
                 * @return {?}
                 */
                error => {
                    reject(error);
                }));
            }
            else {
                this.TokenIdNotificacion(false, first).then((/**
                 * @param {?} id
                 * @return {?}
                 */
                id => {
                    resolve(id);
                })).catch((/**
                 * @param {?} error
                 * @return {?}
                 */
                error => {
                    reject(error);
                }));
            }
        })));
        return promise;
    }
    /**
     * @private
     * @param {?} swReg
     * @return {?}
     */
    NotificacionUserRegistrado(swReg) {
        this.GetUser().then((/**
         * @param {?} snapshot
         * @return {?}
         */
        (snapshot) => {
            this.userName = (snapshot.val()) || {};
            this.fireBaseConnect.Messaging.useServiceWorker(swReg);
            this.fireBaseConnect.Messaging.usePublicVapidKey(this.settings.PublicVapidKey);
            this.fireBaseConnect.Messaging.getToken().then((/**
             * @param {?} token
             * @return {?}
             */
            (token) => {
                this.TokenMessaging = token;
                console.log(`Messaging -----   ${token}`);
                if (this.userName.Token == null)
                    this.SaveDataBase(token);
                if (this.userName.Token != token)
                    this.UpdateToken();
                this.CheckTokenIdUser();
                this.OnMessage();
            }));
        }));
    }
    /**
     * @private
     * @return {?}
     */
    EventFocusMensajes() {
        window.addEventListener('focus', (/**
         * @return {?}
         */
        () => __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            let mensajes = yield this.GetDataMensajes();
            if (mensajes.length > 0) {
                this.FocusSubject.next(mensajes);
                //mensajes.forEach(f => {
                //  this.SaveNotificacionWebPush(f);
                //})
            }
        })));
    }
    /**
     * @return {?}
     */
    GetMensajesUsuario() {
        return __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            let promise = new Promise((/**
             * @param {?} resolve
             * @param {?} reject
             * @return {?}
             */
            (resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                /** @type {?} */
                let mensajes = yield this.fireBaseConnect.DataBase.ref(`sistemas/${this.settings.SistemaId}/notificacion/${this.user.Id}`).once('value');
                /** @type {?} */
                var mensajesArray = [];
                mensajes.forEach((/**
                 * @param {?} f
                 * @return {?}
                 */
                f => {
                    mensajesArray.push(f.val());
                }));
                resolve(mensajesArray);
            })));
            return promise;
        });
    }
    /**
     * @private
     * @return {?}
     */
    GetDataMensajes() {
        /** @type {?} */
        let promise = new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            let request = indexedDB.open('mensajes', 2);
            request.onupgradeneeded = (/**
             * @param {?} e
             * @return {?}
             */
            function (e) {
                if (request.transaction.objectStoreNames.length == 0)
                    e.target.transaction.abort();
            });
            request.onsuccess = (/**
             * @param {?} event
             * @return {?}
             */
            (event) => {
                /** @type {?} */
                let db = request.result;
                db.onerror = (/**
                 * @param {?} event
                 * @return {?}
                 */
                (event) => {
                    console.log(event);
                });
                /** @type {?} */
                let transaccion = null;
                try {
                    transaccion = db.transaction('mensaje.' + this.user.Id, 'readwrite');
                }
                catch (ex) {
                    console.debug(ex);
                }
                if (transaccion != null) {
                    /** @type {?} */
                    let store = transaccion.objectStore('mensaje.' + this.user.Id);
                    /** @type {?} */
                    let all = store.getAll();
                    all.onsuccess = (/**
                     * @param {?} data
                     * @return {?}
                     */
                    (data) => {
                        /** @type {?} */
                        let mensajes = data.target.result;
                        //: Array<MensajeNavBar>
                        /** @type {?} */
                        let clone = [...mensajes];
                        if (mensajes.length > 0) {
                            store.clear();
                        }
                        resolve(clone);
                    });
                }
                else {
                    resolve([]);
                }
            });
        })));
        return promise;
    }
    //mensajesTest() {
    //}
    //SaveNotificacionWebPush(payload) {
    //  this.fireBaseConnect.DataBase.ref(`notificacion/${this.user.Id}/${payload.notification.NotificacionId}`).push(payload.notification).catch(error => {
    //    console.log(error);
    //  })
    //}
    /**
     * @private
     * @return {?}
     */
    OnMessage() {
        this.fireBaseConnect.Messaging.onMessage((/**
         * @param {?} payload
         * @return {?}
         */
        (payload) => {
            console.log(payload);
            this.OnMessaging.emit(payload);
            //this.SaveNotificacionWebPush(payload);
        }), (/**
         * @param {?} error
         * @return {?}
         */
        error => { console.log(error); }), (/**
         * @return {?}
         */
        () => {
            console.log('Completo');
        }));
    }
    /**
     * @param {?} id
     * @return {?}
     */
    DeleteNotificacion(id) {
        this.fireBaseConnect.DataBase.ref(`sistemas/${this.settings.SistemaId}/notificacion/${this.user.Id}/${id}`).remove().then((/**
         * @param {?} error
         * @return {?}
         */
        error => {
            console.log(error);
        }));
    }
    //OnMessaging() {
    //    this.fireBaseConnect.Messaging.onMessage((payload) => {
    //        //console.log('Message received. ', payload);
    //        this.dialogService.NotificacionInfoTitle(payload.notificacion.body, payload.notificacion.title);
    //    })
    //}
    /**
     * @private
     * @return {?}
     */
    GetToken() {
        this.fireBaseConnect.Messaging.getToken().then((/**
         * @param {?} token
         * @return {?}
         */
        (token) => {
            localStorage.setItem("userHr", this.user.Id);
            this.TokenMessaging = token;
            this.SaveDataBase(token);
        }));
    }
    /**
     * @private
     * @return {?}
     */
    UpdateToken() {
        this.fireBaseConnect.Messaging.getToken().then((/**
         * @param {?} token
         * @return {?}
         */
        (token) => {
            this.TokenMessaging = token;
            //console.log(token);
            this.UpdateDataBase(token);
            console.log(`Messaging update-----   ${token}`);
        }));
    }
    /**
     * @private
     * @param {?} token
     * @return {?}
     */
    SaveDataBase(token) {
        /** @type {?} */
        let user = { Token: token };
        console.log(`Messaging Nuevo-----   ${token}`);
        //this.fireBaseConnect.DataBase.ref(`notificacion/${this.user.Id}`).
        this.fireBaseConnect.DataBase.ref(`sistemas/${this.settings.SistemaId}/users/${this.user.Id}`).set(user).catch((/**
         * @param {?} error
         * @return {?}
         */
        (error) => {
            console.log(error);
        }));
    }
    /**
     * @private
     * @param {?} token
     * @return {?}
     */
    UpdateDataBase(token) {
        /** @type {?} */
        let user = { Token: token };
        this.fireBaseConnect.DataBase.ref(`sistemas/${this.settings.SistemaId}/users/${this.user.Id}`).update(user).catch((/**
         * @param {?} error
         * @return {?}
         */
        (error) => {
            console.log(error);
        }));
    }
    /**
     * @private
     * @return {?}
     */
    GetTokenHr() {
        return __awaiter(this, void 0, void 0, function* () {
            //let user = await this.user.User;//
            if (this.user.Id != null)
                return this.callHttp.httpGetText(`${this.baseURL}api/FireBaseApi/GetToken?id=${this.user.Id.toLocaleLowerCase()}$${this.settings.SistemaId}`);
        });
    }
    /**
     * @private
     * @return {?}
     */
    GetUser() {
        return __awaiter(this, void 0, void 0, function* () {
            //let user = await this.user.User;
            return this.fireBaseConnect.DataBase.ref(`sistemas/${this.settings.SistemaId}/users/${this.user.Id}`).once('value');
        });
    }
    /**
     * @return {?}
     */
    Connection() {
        return this.fireBaseConnect;
    }
}
WebPushFirebaseService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
WebPushFirebaseService.ctorParameters = () => [
    { type: FirebaseConnectService },
    { type: CallHttp },
    { type: undefined, decorators: [{ type: Inject, args: [Settings_FireBase,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [EnvironmentToken,] }] },
    { type: String, decorators: [{ type: Inject, args: [BASEURL_FIREBASE,] }] }
];
/** @nocollapse */ WebPushFirebaseService.ngInjectableDef = ɵɵdefineInjectable({ factory: function WebPushFirebaseService_Factory() { return new WebPushFirebaseService(ɵɵinject(FirebaseConnectService), ɵɵinject(CallHttp), ɵɵinject(Settings_FireBase), ɵɵinject(EnvironmentToken), ɵɵinject(BASEURL_FIREBASE)); }, token: WebPushFirebaseService, providedIn: "root" });
if (false) {
    /** @type {?} */
    WebPushFirebaseService.prototype.TokenMessaging;
    /** @type {?} */
    WebPushFirebaseService.prototype.userName;
    /** @type {?} */
    WebPushFirebaseService.prototype.TokenAuth;
    /** @type {?} */
    WebPushFirebaseService.prototype.OnMessaging;
    /** @type {?} */
    WebPushFirebaseService.prototype.user;
    /**
     * @type {?}
     * @private
     */
    WebPushFirebaseService.prototype._TokenId;
    /** @type {?} */
    WebPushFirebaseService.prototype.TokenIdSubject;
    /** @type {?} */
    WebPushFirebaseService.prototype.FocusSubject;
    /**
     * @type {?}
     * @private
     */
    WebPushFirebaseService.prototype._Timer;
    /**
     * @type {?}
     * @private
     */
    WebPushFirebaseService.prototype.fireBaseConnect;
    /**
     * @type {?}
     * @private
     */
    WebPushFirebaseService.prototype.callHttp;
    /**
     * @type {?}
     * @private
     */
    WebPushFirebaseService.prototype.settings;
    /**
     * @type {?}
     * @private
     */
    WebPushFirebaseService.prototype.environment;
    /**
     * @type {?}
     * @private
     */
    WebPushFirebaseService.prototype.baseURL;
}
/**
 * @record
 */
function Time() { }
if (false) {
    /** @type {?} */
    Time.prototype.week_number;
    /** @type {?} */
    Time.prototype.utc_offset;
    /** @type {?} */
    Time.prototype.utc_datetime;
    /** @type {?} */
    Time.prototype.unixtime;
    /** @type {?} */
    Time.prototype.timezone;
    /** @type {?} */
    Time.prototype.raw_offset;
    /** @type {?|undefined} */
    Time.prototype.dst_until;
    /** @type {?} */
    Time.prototype.dst_offset;
    /** @type {?|undefined} */
    Time.prototype.dst_from;
    /** @type {?} */
    Time.prototype.dst;
    /** @type {?} */
    Time.prototype.day_of_year;
    /** @type {?} */
    Time.prototype.day_of_week;
    /** @type {?} */
    Time.prototype.datetime;
    /** @type {?} */
    Time.prototype.client_ip;
    /** @type {?} */
    Time.prototype.abbreviation;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/firebase-token-id.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function FirebaseTokenId() { }
if (false) {
    /** @type {?} */
    FirebaseTokenId.prototype.TokenId;
}
/** @type {?} */
let FIREBASE_TOKENID = new InjectionToken('FireBaseTokenId');

/**
 * @fileoverview added by tsickle
 * Generated from: lib/firebase-token-id.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FirebaseTokenIdService {
    /**
     * @param {?} webPushService
     */
    constructor(webPushService) {
        if (webPushService.TokenId != null) {
            this.TokenId = webPushService.TokenId;
        }
        webPushService.TokenIdSubject.subscribe((/**
         * @param {?} tokenId
         * @return {?}
         */
        tokenId => {
            this.TokenId = tokenId;
        }));
    }
}
FirebaseTokenIdService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
FirebaseTokenIdService.ctorParameters = () => [
    { type: WebPushFirebaseService }
];
/** @nocollapse */ FirebaseTokenIdService.ngInjectableDef = ɵɵdefineInjectable({ factory: function FirebaseTokenIdService_Factory() { return new FirebaseTokenIdService(ɵɵinject(WebPushFirebaseService)); }, token: FirebaseTokenIdService, providedIn: "root" });
if (false) {
    /** @type {?} */
    FirebaseTokenIdService.prototype.TokenId;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/vesta-firebase.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} settings
 * @return {?}
 */
function InitWebApi(settings) {
    //if (settings.SistemaId == null) {
    //  throw 'vesta firebase sistemaId, es obligatorio';
    //} else {
    //  settings.SistemaId = settings.SistemaId.toLowerCase();
    //}
    //if (settings.SistemaId == null) {
    //  throw 'vesta firebase sistemaId, es obligatorio';
    //} else {
    //  settings.SistemaId = settings.SistemaId.toLowerCase();
    //}
    /** @type {?} */
    let direccion = 'https://notificacionesvesta.azurewebsites.net/';
    if (!settings.production)
        direccion = 'https://notificacionesvesta-stage.azurewebsites.net/';
    return direccion;
}
/**
 * @param {?} settings
 * @return {?}
 */
function Init(settings) {
    if (settings.SistemaId == null) {
        throw 'vesta firebase sistemaId, es obligatorio';
    }
    else {
        settings.SistemaId = settings.SistemaId.toLowerCase();
    }
    return settings;
}
class VestaFirebaseModule {
    /**
     * @param {?} setting
     * @param {?=} environment
     * @return {?}
     */
    static forRoot(setting, environment = { production: true }) {
        return {
            ngModule: VestaFirebaseModule,
            providers: [
                { provide: Settings_FireBase_Temp, useValue: setting },
                { provide: Settings_FireBase, useFactory: Init, deps: [Settings_FireBase_Temp] },
                { provide: EnvironmentToken, useValue: environment },
                { provide: BASEURL_FIREBASE, useFactory: InitWebApi, deps: [EnvironmentToken] },
            ]
        };
    }
}
VestaFirebaseModule.decorators = [
    { type: NgModule, args: [{
                declarations: [],
                imports: [
                    CommonModule,
                ],
                providers: [
                    WebPushFirebaseService,
                    FirebaseConnectService,
                    { provide: FIREBASE_TOKENID, useClass: FirebaseTokenIdService }
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/firebase.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class WebpushNotificationFireBase {
    /**
     * @param {?} body
     * @param {?} title
     * @param {?=} data
     * @param {?=} requireInteraction
     * @param {?=} renotify
     * @param {?=} click
     * @return {?}
     */
    static GetWebpushNotificationFireBase(body, title, data = null, requireInteraction = false, renotify = false, click = null) {
        /** @type {?} */
        let obj = new WebpushNotificationFireBase();
        obj.Body = body;
        obj.Title = title;
        obj.Data = data;
        obj.RequireInteraction = requireInteraction;
        obj.Renotify = renotify;
        obj.Click = click;
        return obj;
    }
}
if (false) {
    /** @type {?} */
    WebpushNotificationFireBase.prototype.Body;
    /** @type {?} */
    WebpushNotificationFireBase.prototype.Title;
    /** @type {?} */
    WebpushNotificationFireBase.prototype.Data;
    /** @type {?} */
    WebpushNotificationFireBase.prototype.RequireInteraction;
    /** @type {?} */
    WebpushNotificationFireBase.prototype.Renotify;
    /** @type {?} */
    WebpushNotificationFireBase.prototype.Click;
}
class MessageFireBase {
    /**
     * @param {?} idToken
     * @param {?} id
     * @param {?} title
     * @param {?} body
     * @param {?} notificationWebPush
     * @param {?} data
     * @param {?} sistemaId
     * @return {?}
     */
    static GetMessageFireBase(idToken, id, title, body, notificationWebPush, data, sistemaId) {
        /** @type {?} */
        let obj = new MessageFireBase();
        obj.IdToken = idToken;
        obj.Id = id;
        obj.Title = title;
        obj.Body = body;
        obj.NotificationWebPush = notificationWebPush;
        obj.Data = data;
        obj.SistemaId = sistemaId;
        return obj;
    }
}
if (false) {
    /** @type {?} */
    MessageFireBase.prototype.IdToken;
    /** @type {?} */
    MessageFireBase.prototype.Id;
    /** @type {?} */
    MessageFireBase.prototype.Title;
    /** @type {?} */
    MessageFireBase.prototype.Body;
    /** @type {?} */
    MessageFireBase.prototype.NotificationWebPush;
    /** @type {?} */
    MessageFireBase.prototype.Data;
    /** @type {?} */
    MessageFireBase.prototype.SistemaId;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/notificacion-firebase.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NotificacionFirebaseService {
    /**
     * @param {?} callHttp
     * @param {?} dialogService
     * @param {?} token
     * @param {?} baseURL
     * @param {?} settings
     */
    constructor(callHttp, dialogService, token, baseURL, settings) {
        this.callHttp = callHttp;
        this.dialogService = dialogService;
        this.token = token;
        this.baseURL = baseURL;
        this.settings = settings;
    }
    /**
     * @param {?} notificacion
     * @param {?} usuarioNotificacionId
     * @param {?=} sistemaId
     * @return {?}
     */
    SendNotificacion(notificacion, usuarioNotificacionId, sistemaId = this.settings.SistemaId) {
        if (usuarioNotificacionId == "00000000-0000-0000-0000-000000000000" ||
            usuarioNotificacionId == null) {
            this.dialogService.NotificacionAlert('Id de usuario invalido, notificacion no enviada...');
            return void 0;
        }
        /** @type {?} */
        let webPushMensaje = MessageFireBase.GetMessageFireBase(this.token.TokenId, usuarioNotificacionId, null, null, notificacion, null, sistemaId);
        this.callHttp.httpPostText(`${this.baseURL}api/FireBaseApi/sendmessaging`, webPushMensaje)
            .subscribe((/**
         * @param {?} response
         * @return {?}
         */
        response => {
            console.log(response);
        }));
    }
}
NotificacionFirebaseService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
NotificacionFirebaseService.ctorParameters = () => [
    { type: CallHttp },
    { type: DialogService },
    { type: undefined, decorators: [{ type: Inject, args: [FIREBASE_TOKENID,] }] },
    { type: String, decorators: [{ type: Inject, args: [BASEURL_FIREBASE,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [Settings_FireBase,] }] }
];
/** @nocollapse */ NotificacionFirebaseService.ngInjectableDef = ɵɵdefineInjectable({ factory: function NotificacionFirebaseService_Factory() { return new NotificacionFirebaseService(ɵɵinject(CallHttp), ɵɵinject(DialogService), ɵɵinject(FIREBASE_TOKENID), ɵɵinject(BASEURL_FIREBASE), ɵɵinject(Settings_FireBase)); }, token: NotificacionFirebaseService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    NotificacionFirebaseService.prototype.callHttp;
    /**
     * @type {?}
     * @private
     */
    NotificacionFirebaseService.prototype.dialogService;
    /**
     * @type {?}
     * @private
     */
    NotificacionFirebaseService.prototype.token;
    /**
     * @type {?}
     * @private
     */
    NotificacionFirebaseService.prototype.baseURL;
    /**
     * @type {?}
     * @private
     */
    NotificacionFirebaseService.prototype.settings;
}

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: vesta-firebase.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { BASEURL_FIREBASE, EnvironmentToken, FIREBASE_TOKENID, FirebaseConnectService, Init, InitWebApi, MessageFireBase, NotificacionFirebaseService, Settings_FireBase, Settings_FireBase_Temp, VestaFirebaseModule, WebPushFirebaseService, WebpushNotificationFireBase, FirebaseTokenIdService as ɵa };
//# sourceMappingURL=vesta-firebase.js.map
